import bem from 'utils/bem';

export const block = bem('text-transition-select');
